"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotDollarStack = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotDollarStack = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M20.425 9.6c3.183.718 8.903.917 12.588 4.527 3.684 3.62 6.331 9.973 4.26 13.616-2.082 3.632-8.958 3.2-14.948 4.657-6.001 1.467-11.18 3.481-14.8 1.852-3.61-1.627-5.564-5.545-6.643-10.077C-.206 19.644-.324 15.851.733 12.68c1.046-3.17 3.29-5.71 5.84-6.545 2.564-.825 4.452-.114 6.727.615 1.855.792 3.933 2.121 7.125 2.85Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeWidth: 2,
    d: "M10.25 25.625V29a1 1 0 0 0 1 1h20.5a1 1 0 0 0 1-1V16a1 1 0 0 0-1-1H29"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: 22.5,
    height: 15,
    x: 5.25,
    y: 10,
    stroke: color,
    strokeWidth: 2,
    rx: 1
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.5 12.5v1.818m2.083 0h-3.125a1.4 1.4 0 0 0-1.03.466A1.667 1.667 0 0 0 14 15.909c0 .422.154.826.427 1.125a1.4 1.4 0 0 0 1.031.466h2.084a1.4 1.4 0 0 1 1.03.466c.274.298.428.703.428 1.125 0 .422-.154.826-.427 1.125a1.4 1.4 0 0 1-1.031.466H16.5m-2.5 0h2.5m0 0V22.5"
  }));
};
exports.SpotDollarStack = SpotDollarStack;
SpotDollarStack.displayName = "SpotDollarStack";